import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChartLineFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.313 19.351H7.757a1.9 1.9 0 0 1-1.894-1.899V15.85a2.37 2.37 0 0 0 1.615-2.237 2.33 2.33 0 0 0-.316-1.156l1.992-2.389c.287.124.603.195.935.195.339 0 .659-.075.951-.204l1.892 2.233c-.19.34-.308.725-.308 1.141v.023a2.367 2.367 0 0 0 2.366 2.347 2.37 2.37 0 0 0 2.363-2.37c0-.42-.12-.81-.314-1.152l1.873-2.235c.298.136.626.217.974.217a2.365 2.365 0 1 0-2.363-2.37c0 .408.113.786.295 1.122l-1.889 2.255a2.34 2.34 0 0 0-1.89.006l-1.894-2.234a2.35 2.35 0 0 0 .31-1.149 2.365 2.365 0 0 0-4.73 0c0 .425.121.82.318 1.164l-1.992 2.391c-.061-.026-.126-.042-.189-.063V3.902a.75.75 0 0 0-1.5 0v7.484a2.36 2.36 0 0 0-1.612 2.226c0 1.042.679 1.92 1.613 2.236v1.604a3.4 3.4 0 0 0 3.394 3.4h13.556a.75.75 0 1 0 0-1.5"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChartLineFilled);
export default ForwardRef;
